import React, { Component } from 'react'
import css from './styles.scss'
import { connect } from 'react-redux'
import { getItem, storeItem } from '../../actions/actions'
import EditorGUI from '../EditorGUI'
import EditorRaw from '../EditorRaw'
import { withRouter } from 'react-router-dom'

export class Item extends Component {
  constructor ({ match: { params: { itemId } }, dispatch, match }) {
    super()
    this.state = {
      loading: !!itemId,
      chosenFormat: false
    }
  }

  componentDidMount () {
    if (this.props.match.params.itemId) {
      this.props.dispatch(getItem(this.props.match.params.itemId)).then(() => {
        this.setState({
          loading: false
        })
      })
    }
  }

  handleNewBasic = () => {
    this.props.dispatch(storeItem({ data: {} }))
  }

  handleNewAdvanced = () => {
    this.props.dispatch(storeItem({ code: '' }))
  }

  componentWillReceiveProps (nextProps) {
    const { itemId: nextId } = nextProps.match.params
    const { itemId: currentId } = this.props.match.params
    if (nextId !== currentId && nextId) {
      this.setState({
        loading: !!nextId
      })
      this.props.dispatch(getItem(nextId)).then(() => {
        this.setState({
          loading: false
        })
      })
    }
  }

  render () {
    const { loading } = this.state
    const { app: { primaryColor } } = this.props
    const { match: { params: { itemId: id } }, item: { code, data }, app: { standAloneMode } } = this.props
    let page = null
    if (loading) {
      page = <div className={css.loading}>Loading...</div>
    } else if (typeof code === 'string') {
      page = <EditorRaw id={id} />
    } else if (typeof data === 'object' && data !== null) { // that's javascript baby
      page = <EditorGUI id={id} />
    } else {
      page = (
        <div className={`${css.container} ${standAloneMode ? css.containerStandAlone : ''}`}>
          <div className={css.column}>
            <button type='button' className={css.btn} onClick={this.handleNewBasic} style={{ backgroundColor: primaryColor }}>Use the graphical interface</button>
            <p className={css.p}>
                Define variables and drag them into your content
            </p>
            <div className={css.img1} />
          </div>
          <div className={css.column}>
            <button
              className={css.btn} type='button' onClick={this.handleNewAdvanced}
              style={{ backgroundColor: primaryColor }}
            >Use the code editor
            </button>
            <p className={css.p}>
                Write code that generates item instances
            </p>
            <div className={css.img2} />
          </div>
        </div>
      )
    }
    return (
      <article className={`${css.Item} ${standAloneMode ? css.ItemStandAlone : ''}`}>
        {page}
      </article>
    )
  }
}

const mapStateToProps = state => {
  const { app, auth, item } = state
  return {
    app,
    auth,
    item
  }
}

export default withRouter(connect(mapStateToProps)(Item))



// WEBPACK FOOTER //
// /app/js/components/Item/index.js